import RouterScrollToTop from './RouterScrollToTop';
export default RouterScrollToTop;
